// extracted by mini-css-extract-plugin
module.exports = {"price":"fS","onSale":"gS"};